import { getTemplateWithClass } from '../helpers';

export default function (data) {
  return getTemplateWithClass(data.cellValue, 'overdue');
}
